import { ResforCode } from './ResforCode'
import { ProvinceCode } from '../Localization/Province'
import { CountyCode } from '../Localization/County'
import { ParishCode } from '../Localization/Parish'
import { ResforYear } from './ResforYear'
import { ResforNif } from './ResforNif'
import { PostalCode } from './PostalCode'
import { ResforName } from './ResforName'
import { ResforAddress } from './ResforAddress'
import { PlaceCode } from '../Localization/Place'
import { ResforEmail } from './ResforEmail'
import { ResforPhone } from './ResforPhone'

export class ResforData {
  private _code: ResforCode
  private _resforYear: ResforYear
  private _resforNif: ResforNif
  private _resforEmail: ResforEmail | null
  private _resforPhone: ResforPhone | null
  private _resforFax: ResforPhone | null
  private _resforMobile: ResforPhone | null
  private _provinceCode: ProvinceCode | null
  private _countyCode: CountyCode | null
  private _parishCode: ParishCode | null
  private _placeCode: PlaceCode | null
  private _postalCode: PostalCode | null
  private _resforName: ResforName | null
  private _resforAddress: ResforAddress | null

  constructor (
    code: ResforCode,
    resforNif: ResforNif,
    resforYear: ResforYear,
    resforName: ResforName | null,
    resforEmail?: ResforEmail | null,
    resforPhone?: ResforPhone | null,
    resforFax?: ResforPhone | null,
    resforMobile?: ResforPhone | null,
    provinceCode?: ProvinceCode | null,
    countyCode?: CountyCode | null,
    parishCode?: ParishCode | null,
    placeCode?: PlaceCode | null,
    postalCode?: PostalCode | null,
    resforAddress?: ResforAddress | null
  ) {
    this._code = code
    this._resforYear = resforYear
    this._resforNif = resforNif
    this._provinceCode = provinceCode === undefined ? null : provinceCode
    this._countyCode = countyCode === undefined ? null : countyCode
    this._parishCode = parishCode === undefined ? null : parishCode
    this._placeCode = placeCode === undefined ? null : placeCode
    this._postalCode = postalCode === undefined ? null : postalCode
    this._resforName = resforName === undefined ? null : resforName
    this._resforAddress = resforAddress === undefined ? null : resforAddress
    this._resforEmail = resforEmail === undefined ? null : resforEmail
    this._resforPhone = resforPhone === undefined ? null : resforPhone
    this._resforFax = resforFax === undefined ? null : resforFax
    this._resforMobile = resforMobile === undefined ? null : resforMobile
  }

  email (): string {
    return this._resforEmail === null ? '' : this._resforEmail.email()
  }

  phone (): string {
    return this._resforPhone === null ? '' : this._resforPhone.phoneNumber()
  }

  fax (): string {
    return this._resforFax === null ? '' : this._resforFax.phoneNumber()
  }

  mobile (): string {
    return this._resforMobile === null ? '' : this._resforMobile.phoneNumber()
  }

  resforCode (): string {
    return this._code.value()
  }

  provinceCode (): number {
    return this._provinceCode === null ? 0 : this._provinceCode.value()
  }

  countyCode (): number {
    return this._countyCode === null ? 0 : this._countyCode.value()
  }

  parishCode (): number {
    return this._parishCode === null ? 0 : this._parishCode.value()
  }

  placeCode (): number {
    return this._placeCode === null ? 0 : this._placeCode.value()
  }

  lastComunicationYear (): string {
    return this._resforYear.year()
  }

  identityCode (): string {
    return this._resforNif.codeId()
  }

  postalCode (): string {
    return this._postalCode === null ? '' : this._postalCode.code()
  }

  name (): string {
    return this._resforName === null ? '' : this._resforName.value()
  }

  address (): string {
    return this._resforAddress === null ? '' : this._resforAddress.value()
  }
}
